'use client';
import AppLayout from '@/components/AppLayout';
import DocumentVault from './components/DocumentVault';

export default function DocumentVaultPage() {
  return (
    <AppLayout portalName="Investor Portal" portalRole="investor">
      <DocumentVault />
    </AppLayout>
  );
}
